// Centralized data configuration for all services
export const servicesData = {
  cloudVPS: {
    name: 'Cloud VPS',
    description: 'Virtual Private Server dans le cloud',
    allowExtension: true, // Autoriser l'extension de durée
    operatingSystems: [
      { 
        id: 'debian', 
        name: 'Debian', 
        icon: 'debian',
        disabled: false,
        versions: [
          { id: 'latest', name: 'Latest (12 Bookworm)', isDefault: true, disabled: false },
          { id: '11', name: '11 Bullseye', disabled: false },
          // { id: '10', name: '10 Buster', disabled: true },
          // { id: '9', name: '9 Stretch', disabled: true }
        ]
      },
      { 
        id: 'ubuntu', 
        name: 'Ubuntu', 
        icon: 'ubuntu',
        disabled: false,
        versions: [
          { id: 'latest', name: 'Latest (24.04 LTS)', isDefault: true, disabled: false },
          { id: '22.04', name: '22.04 LTS', disabled: false },
          // { id: '20.04', name: '20.04 LTS', disabled: true },
          // { id: '18.04', name: '18.04 LTS', disabled: true }
        ]
      },
      { 
        id: 'fedora', 
        name: 'Fedora', 
        icon: 'fedora',
        disabled: false,
        versions: [
          { id: 'latest', name: 'Latest (42)', isDefault: true, disabled: false },
          { id: '41', name: '41', disabled: false },
          // { id: '39', name: '39', disabled: true },
          // { id: '38', name: '38', disabled: true },
          // { id: '37', name: '37', disabled: true }
        ]
      },
      { 
        id: 'centos', 
        name: 'CentOS Stream', 
        icon: 'centos',
        disabled: false,
        versions: [
          { id: 'latest', name: 'Latest (Stream 10)', isDefault: true, disabled: false },
          { id: 'stream9', name: 'Stream 9', disabled: false },
          // { id: 'stream8', name: 'Stream 8', disabled: true },
          // { id: '7', name: '7', disabled: true },
          // { id: '6', name: '6', disabled: true }
        ]
      },
      { 
        id: 'opensuse', 
        name: 'openSUSE', 
        icon: 'opensuse',
        disabled: true,
        versions: [
          { id: 'latest', name: 'Leap 15', isDefault: true, disabled: false },
          // { id: 'leap15.5', name: 'Leap 15.5', disabled: true },
          // { id: 'leap15.4', name: 'Leap 15.4', disabled: true },
          // { id: 'leap15.3', name: 'Leap 15.3', disabled: true }
        ]
      }
    ],
    durations: [
      { id: '4d', name: '4 jours', multiplier: 4/30 },
      { id: '7d', name: '7 jours', multiplier: 7/30 },
      { id: '2w', name: '2 semaines', multiplier: 14/30 },
      { id: '4w', name: '4 semaines', multiplier: 1 },
      { id: '2m', name: '2 mois', multiplier: 2 },
      { id: '4m', name: '4 mois', multiplier: 4 },
      { id: '6m', name: '6 mois', multiplier: 6 },
      { id: '12m', name: '12 mois', multiplier: 12 }
    ],
    configurations: [
      { 
        id: 'standard', 
        name: 'Standard', 
        price: 5500, 
        specs: '2 vCPU, 4GB RAM, 40GB SSD' 
      },
      { 
        id: 'silver', 
        name: 'Silver', 
        price: 9500, 
        specs: '4 vCPU, 8GB RAM, 80GB SSD' 
      },
      { 
        id: 'gold', 
        name: 'Gold', 
        price: 24000, 
        specs: '8 vCPU, 16GB RAM, 160GB SSD' 
      },
      { 
        id: 'platinum', 
        name: 'Platinum', 
        price: 47000, 
        specs: '16 vCPU, 32GB RAM, 320GB SSD' 
      }
    ]
  },

  orchestrator: {
    name: 'Orchestrator',
    description: 'Orchestration de conteneurs',
    allowExtension: true, // Autoriser l'extension de durée
    types: [
      { 
        id: 'kubernetes', 
        name: 'Kubernetes', 
        icon: 'kubernetes',
        disabled: false,
        versions: [
          { id: 'microk8s', name: 'MicroK8s', isDefault: true, type: 'microk8s', disabled: false },
          { id: 'minikube', name: 'Minikube', type: 'minikube', disabled: true }
        ]
      },
      { id: 'docker', name: 'Docker', icon: 'docker', disabled: false },
      { id: 'podman', name: 'Podman', icon: 'podman', disabled: false }
    ],
    durations: [
      { id: '4d', name: '4 jours', multiplier: 4/30 },
      { id: '7d', name: '7 jours', multiplier: 7/30 },
      { id: '2w', name: '2 semaines', multiplier: 14/30 },
      { id: '4w', name: '4 semaines', multiplier: 1 },
      { id: '2m', name: '2 mois', multiplier: 2 },
      { id: '4m', name: '4 mois', multiplier: 4 },
      { id: '6m', name: '6 mois', multiplier: 6 },
      { id: '12m', name: '12 mois', multiplier: 12 }
    ],
    configurations: [
      { 
        id: 'standard', 
        name: 'Standard', 
        price: 5500, 
        specs: '2 vCPU, 4GB RAM, 40GB SSD' 
      },
      { 
        id: 'silver', 
        name: 'Silver', 
        price: 9500, 
        specs: '4 vCPU, 8GB RAM, 80GB SSD' 
      },
      { 
        id: 'gold', 
        name: 'Gold', 
        price: 24000, 
        specs: '8 vCPU, 16GB RAM, 160GB SSD' 
      },
      { 
        id: 'platinum', 
        name: 'Platinum', 
        price: 47000, 
        specs: '16 vCPU, 32GB RAM, 320GB SSD' 
      }
    ]
  },

  dbaas: {
    name: 'DBaaS',
    description: 'Database as a Service',
    allowExtension: true, // Autoriser l'extension de durée
    databases: [
      { 
        id: 'mysql', 
        name: 'MySQL / MariaDB', 
        icon: 'mysql',
        disabled: false,
        ramImportant: false,
        versions: [
          // { id: 'mysql-latest', name: 'MySQL Latest (8.4 LTS)', isDefault: true, type: 'mysql', disabled: true },
          // { id: 'mysql-8.0', name: 'MySQL 8.0', type: 'mysql', disabled: true },
          // { id: 'mysql-5.7', name: 'MySQL 5.7', type: 'mysql', disabled: true },
          // { id: 'mysql-5.6', name: 'MySQL 5.6', type: 'mysql', disabled: true },
          { id: 'mariadb-latest', name: 'MariaDB Latest (11.4)', version: '11.4', isDefault: true, type: 'mariadb', disabled: false },
          { id: 'mariadb-10.11', name: 'MariaDB 10.11 LTS', version: '10.11', type: 'mariadb', disabled: false },
          { id: 'mariadb-10.6', name: 'MariaDB 10.6 LTS', version: '10.6', type: 'mariadb', disabled: true }
        ]
      },
      { 
        id: 'postgresql', 
        name: 'PostgreSQL', 
        icon: 'postgresql',
        disabled: false,
        ramImportant: false,
        versions: [
          { id: 'latest', name: 'Latest (17)', version: '17', isDefault: true, disabled: false },
          { id: '16', name: '16', version: '16', disabled: false },
          { id: '15', name: '15', version: '15', disabled: false }
        ]
      },
      { 
        id: 'redis', 
        name: 'Redis', 
        icon: 'redis',
        disabled: false,
        ramImportant: true,
        ramConfigurations: [
          { id: 'ram-1gb', name: '512MB RAM', ram: 1, price: 2000, specs: '1 vCPU, 512MB RAM, 1GB SSD' },
          { id: 'ram-5gb', name: '1GB RAM', ram: 5, price: 6000, specs: '1 vCPU, 1GB RAM, 1GB SSD' },
          { id: 'ram-10gb', name: '2GB RAM', ram: 10, price: 12000, specs: '1 vCPU, 2GB RAM, 2GB SSD' }
        ],
        versions: [
          { id: 'latest', name: 'Latest (7.2.6)', version: '7.2.6', isDefault: true, disabled: false },
          { id: '7.2.0', name: '7.2.0', version: '7.2.0', disabled: false },
          { id: '7.0.15', name: '7.0.15', version: '7.0.15', disabled: false }
        ]
      },
      { 
        id: 'mongodb', 
        name: 'MongoDB', 
        icon: 'mongodb',
        disabled: false,
        ramImportant: false,
        ramConfigurations: [],
        versions: [
          { id: 'latest', name: 'Latest (7.0)', version: '7.0', isDefault: true, disabled: false },
          { id: '6.0', name: '6.0', version: '6.0', disabled: false },
          { id: '5.0', name: '5.0', version: '5.0', disabled: false }
        ]
      }
    ],
    durations: [
      { id: '4d', name: '4 jours', multiplier: 4/30 },
      { id: '7d', name: '7 jours', multiplier: 7/30 },
      { id: '2w', name: '2 semaines', multiplier: 14/30 },
      { id: '4w', name: '4 semaines', multiplier: 1 },
      { id: '2m', name: '2 mois', multiplier: 2 },
      { id: '4m', name: '4 mois', multiplier: 4 },
      { id: '6m', name: '6 mois', multiplier: 6 },
      { id: '12m', name: '12 mois', multiplier: 12 }
    ],
    configurations: [
      { 
        id: 'basic', 
        name: 'Basic', 
        price: 3500, 
        specs: '1 vCPU, 1GB RAM, 10GB SSD' 
      },
      { 
        id: 'standard', 
        name: 'Standard', 
        price: 6000, 
        specs: '1 vCPU, 2GB RAM, 80GB SSD' 
      },
      { 
        id: 'premium', 
        name: 'Premium', 
        price: 9000, 
        specs: '2 vCPU, 4GB RAM, 160GB SSD' 
      },
      { 
        id: 'gold', 
        name: 'Gold', 
        price: 12000, 
        specs: '2 vCPU, 8GB RAM, 320GB SSD' 
      },
      // { 
      //   id: 'platinum', 
      //   name: 'Platinum', 
      //   price: 12000, 
      //   specs: '8 vCPU, 16GB RAM, 320GB SSD' 
      // }
    ]
  },

  domains: {
    name: 'Domaines',
    description: 'Enregistrement et gestion de noms de domaine',
    allowExtension: false, // Autoriser l'extension de durée
    paymentYears: [
      { id: '1y', name: '1 an', multiplier: 1, discount: 0 },
      { id: '2y', name: '2 ans', multiplier: 2, discount: 5 },
      { id: '3y', name: '3 ans', multiplier: 3, discount: 10 }
    ],
    extensions: [
      { extension: '.net', purchasePrice: 8567, salePrice: 12500, renewalPrice: 12500 },
      { extension: '.com', purchasePrice: 7445, salePrice: 12000, renewalPrice: 12000 },
      { extension: '.org', purchasePrice: 4937, salePrice: 8000, renewalPrice: 8000 },
      { extension: '.clic', purchasePrice: 11207, salePrice: 15000, renewalPrice: 15000 },
      { extension: '.cc', purchasePrice: 3947, salePrice: 6000, renewalPrice: 6000 },
      { extension: '.ai', purchasePrice: 59387, salePrice: 75000, renewalPrice: 80000 },
      { extension: '.academy', purchasePrice: 7247, salePrice: 9500, renewalPrice: 9500 },
      { extension: '.courses', purchasePrice: 23747, salePrice: 30000, renewalPrice: 30000 },
      { extension: '.education', purchasePrice: 20447, salePrice: 26000, renewalPrice: 25000 },
      { extension: '.help', purchasePrice: 1848, salePrice: 5000, renewalPrice: 5000 },
      { extension: '.school', purchasePrice: 21107, salePrice: 30000, renewalPrice: 30000 },
      { extension: '.science', purchasePrice: 8567, salePrice: 15000, renewalPrice: 15000 },
      { extension: '.study', purchasePrice: 23747, salePrice: 30000, renewalPrice: 30000 },
      { extension: '.institute', purchasePrice: 3947, salePrice: 6000, renewalPrice: 6000 },
      { extension: '.support', purchasePrice: 3287, salePrice: 5500, renewalPrice: 5500 },
      { extension: '.online', purchasePrice: 647, salePrice: 2500, renewalPrice: 2500 },
      { extension: '.xyz', purchasePrice: 1320, salePrice: 4000, renewalPrice: 4000 },
      { extension: '.site', purchasePrice: 647, salePrice: 2500, renewalPrice: 2500 },
      { extension: '.store', purchasePrice: 647, salePrice: 2500, renewalPrice: 2500 },
      { extension: '.art', purchasePrice: 1307, salePrice: 3500, renewalPrice: 3500 },
      { extension: '.website', purchasePrice: 647, salePrice: 2500, renewalPrice: 2500 },
      { extension: '.space', purchasePrice: 647, salePrice: 2500, renewalPrice: 2500 },
      { extension: '.autos', purchasePrice: 1188, salePrice: 3500, renewalPrice: 3500 },
      { extension: '.beauty', purchasePrice: 1188, salePrice: 3500, renewalPrice: 3500 },
      { extension: '.cfd', purchasePrice: 990, salePrice: 3500, renewalPrice: 3500 },
      { extension: '.click', purchasePrice: 1188, salePrice: 3500, renewalPrice: 3500 },
      { extension: '.home', purchasePrice: 1188, salePrice: 3500, renewalPrice: 3500 },
      { extension: '.lol', purchasePrice: 1188, salePrice: 3500, renewalPrice: 3500 },
      { extension: '.hair', purchasePrice: 1188, salePrice: 3500, renewalPrice: 3500 },
      { extension: '.shop', purchasePrice: 858, salePrice: 3500, renewalPrice: 3500 },
      { extension: '.bon', purchasePrice: 1775, salePrice: 4000, renewalPrice: 4000 },
      { extension: '.cam', purchasePrice: 1967, salePrice: 4000, renewalPrice: 4000 },
      { extension: '.cloud', purchasePrice: 3287, salePrice: 5500, renewalPrice: 5500 },
      { extension: '.ink', purchasePrice: 1967, salePrice: 4000, renewalPrice: 4000 },
      { extension: '.live', purchasePrice: 1967, salePrice: 4000, renewalPrice: 4000 },
      { extension: '.life', purchasePrice: 1637, salePrice: 4000, renewalPrice: 4000 },
      { extension: '.today', purchasePrice: 1967, salePrice: 4000, renewalPrice: 4000 },
      { extension: '.wiki', purchasePrice: 1967, salePrice: 4000, renewalPrice: 4000 },
      { extension: '.world', purchasePrice: 1637, salePrice: 4000, renewalPrice: 4000 },
      { extension: '.info', purchasePrice: 2310, salePrice: 4500, renewalPrice: 4500 }
    ]
  },

  cmsaas: {
    name: 'CMSaaS',
    description: 'CMS en tant que service - Déploiement automatique',
    allowExtension: true, // Autoriser l'extension de durée
    cms: [
      { 
        id: 'wordpress', 
        name: 'WordPress', 
        icon: 'wordpress',
        description: 'Le CMS le plus populaire au monde',
        disabled: true
      },
      { 
        id: 'joomla', 
        name: 'Joomla', 
        icon: 'joomla',
        description: 'CMS flexible et puissant',
        disabled: true
      },
      { 
        id: 'drupal', 
        name: 'Drupal', 
        icon: 'drupal',
        description: 'CMS avancé pour sites complexes',
        disabled: true
      }
    ],
    configurations: [
      { 
        id: 'standard', 
        name: 'Standard', 
        price: 8500, 
        specs: '2 vCPU, 4GB RAM, 50GB SSD, SSL inclus' 
      },
      { 
        id: 'silver', 
        name: 'Silver', 
        price: 15000, 
        specs: '4 vCPU, 8GB RAM, 100GB SSD, SSL + CDN' 
      },
      { 
        id: 'gold', 
        name: 'Gold', 
        price: 28000, 
        specs: '8 vCPU, 16GB RAM, 200GB SSD, SSL + CDN + Backup' 
      }
    ]
  },

  dedicatedServer: {
    name: 'Serveur Dédié',
    description: 'Serveur dédié haute performance',
    allowExtension: true, // Autoriser l'extension de durée
    operatingSystems: [
      { id: 'windows2025', name: 'Windows Server 2025', icon: 'windows', disabled: false },
      { id: 'windows2022', name: 'Windows Server 2022', icon: 'windows', disabled: false },
      { id: 'windows2019', name: 'Windows Server 2019', icon: 'windows', disabled: false },
      { id: 'windows2016', name: 'Windows Server 2016', icon: 'windows', disabled: true },
      { id: 'n8n', name: 'n8n Workflow Automation', icon: 'linux', disabled: false }
    ],
    configurations: [
      { 
        id: 'dedihostm1', 
        name: 'DEDIHOSTM1', 
        vm_code: "V91",
        price: 15000, 
        specs: '3 CPU, 8GB RAM, 75GB SSD' 
      },
      { 
        id: 'dedihostm2', 
        name: 'DEDIHOSTM2', 
        vm_code: "V94",
        price: 26000, 
        specs: '6 CPU, 12GB RAM, 100GB SSD' 
      },
      { 
        id: 'dedihosts3', 
        name: 'DEDIHOSTS3', 
        vm_code: "V97",
        price: 40000, 
        specs: '8 CPU, 24GB RAM, 200GB SSD' 
      },
      { 
        id: 'dedihosts4', 
        name: 'DEDIHOSTS4',
        vm_code: "V100", 
        price: 66000, 
        specs: '12 CPU, 48GB RAM, 250GB SSD' 
      },
      { 
        id: 'dedihosts4plus', 
        name: 'DEDIHOSTS4+', 
        vm_code: "V103", 
        price: 85000, 
        specs: '16 CPU, 64GB RAM, 300GB SSD' 
      },
      { 
        id: 'dedihosts5', 
        name: 'DEDIHOSTS5',
        vm_code: "V106", 
        price: 105000, 
        specs: '18 CPU, 96GB RAM, 350GB SSD' 
      }
    ]
  },

  storage: {
    name: 'Storage',
    description: 'Solutions de stockage cloud sécurisé',
    allowExtension: true, // Autoriser l'extension de durée
    types: [
      { 
        id: 'mapatabucket', 
        name: 'MapataBucket', 
        icon: 'bucket',
        description: 'Stockage objet S3-compatible pour vos fichiers et applications',
        disabled: false
      },
      { 
        id: 'mapatabox', 
        name: 'MapataBox', 
        icon: 'box',
        description: 'Stockage bloc haute performance pour vos serveurs',
        disabled: false
      }
    ],
    durations: [
      { id: '4d', name: '4 jours', multiplier: 4/30 },
      { id: '7d', name: '7 jours', multiplier: 7/30 },
      { id: '2w', name: '2 semaines', multiplier: 14/30 },
      { id: '4w', name: '4 semaines', multiplier: 1 },
      { id: '2m', name: '2 mois', multiplier: 2 },
      { id: '4m', name: '4 mois', multiplier: 4 },
      { id: '6m', name: '6 mois', multiplier: 6 },
      { id: '12m', name: '12 mois', multiplier: 12 }
    ],
    capacities: [
      { 
        id: '1tb', 
        name: '1 TB', 
        capacity: '1 TB',
        price: 8000,
        details: '1000 GB de stockage'
      },
      { 
        id: '2tb', 
        name: '2 TB', 
        capacity: '2 TB',
        price: 15000,
        details: '2000 GB de stockage'
      },
      { 
        id: '3tb', 
        name: '3 TB', 
        capacity: '3 TB',
        price: 21000,
        details: '3000 GB de stockage'
      },
      { 
        id: '4tb', 
        name: '4 TB', 
        capacity: '4 TB',
        price: 27000,
        details: '4000 GB de stockage'
      },
      { 
        id: '5tb', 
        name: '5 TB', 
        capacity: '5 TB',
        price: 32000,
        details: '5000 GB de stockage'
      },
      { 
        id: '6tb', 
        name: '6 TB', 
        capacity: '6 TB',
        price: 37000,
        details: '6000 GB de stockage'
      },
      { 
        id: '7tb', 
        name: '7 TB', 
        capacity: '7 TB',
        price: 42000,
        details: '7000 GB de stockage'
      },
      { 
        id: '8tb', 
        name: '8 TB', 
        capacity: '8 TB',
        price: 46000,
        details: '8000 GB de stockage'
      },
      { 
        id: '9tb', 
        name: '9 TB', 
        capacity: '9 TB',
        price: 50000,
        details: '9000 GB de stockage'
      },
      { 
        id: '10tb', 
        name: '10 TB', 
        capacity: '10 TB',
        price: 54000,
        details: '10000 GB de stockage'
      }
    ]
  }
};

// Service status - Les statuts sont maintenant récupérés UNIQUEMENT depuis l'API
// Endpoint: GET https://api.mapatacloud.com/config/categories
// Plus de valeurs par défaut en local - tout est géré côté backend
// Rafraîchissement automatique toutes les 60 secondes

// Utility functions
export const calculatePrice = (basePrice, duration, osModifier = 0, paymentYears = null) => {
  let totalPrice = (basePrice + osModifier) * duration;
  
  if (paymentYears) {
    totalPrice = totalPrice * paymentYears.multiplier;
    if (paymentYears.discount > 0) {
      totalPrice = totalPrice * (1 - paymentYears.discount / 100);
    }
  }
  
  // Arrondir le prix final pour supprimer les virgules
  return Math.round(totalPrice);
};

export const calculateDatabasePrice = (ramConfig, duration, paymentYears = null) => {
  let totalPrice = ramConfig.price * duration;
  
  if (paymentYears) {
    totalPrice = totalPrice * paymentYears.multiplier;
    if (paymentYears.discount > 0) {
      totalPrice = totalPrice * (1 - paymentYears.discount / 100);
    }
  }
  
  // Arrondir le prix final pour supprimer les virgules
  return Math.round(totalPrice);
};

export const formatPrice = (price) => {
  // S'assurer que le prix est arrondi avant le formatage
  const roundedPrice = Math.round(price);
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'XAF',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(roundedPrice).replace('XAF', 'FCFA');
};
